import useCurrentUser from '@/composables/user/user'
import { Dictionary } from '@/composables/advert/advertManager'

export enum OfferLinkPosition {
  CROSSROADS_SUBSCRIPTION_TYPE = 'crossroads_subscription_type',
  CROSSROADS_SUBSCRIPTION_OFFER = 'crossroads_subscription_offer',
  CROSSROADS_SUPER_LIKE_OFFER = 'crossroads_super_like_offer',
  POST_TOOLTIP_EDIT = 'post_tooltip_edit',
  POST_TOOLTIP_SUPER_LIKE_UPGRADE_TO_PREMIUM = 'post_tooltip_super_like_upgrade_to_premium',
  POST_TOOLTIP_SUPER_LIKE_BUY_SUBSCRIPTION = 'post_tooltip_super_like_buy_subscription',
}

const urlCache: Dictionary<string> = {}

export function useRefManager() {
  const { currentUser } = useCurrentUser()

  const getSubSuffix = () => {
    if (currentUser.value?.isSubscriptionPremium) {
      return '_premium'
    }
    if (currentUser.value?.isPayingCustomer) {
      return ''
    }
    if (false === currentUser.value?.isPayingCustomer) {
      return '_np'
    }

    return ''
  }

  const addRef = (position: OfferLinkPosition, urlString: string): string => {
    const url = new URL(urlString)
    const key = url.toString() + position

    if (key in urlCache) {
      return urlCache[key]
    }

    let ref: string | undefined = undefined

    switch (position) {
      case OfferLinkPosition.CROSSROADS_SUBSCRIPTION_TYPE:
        ref = 'static_diskusie_profil_np' + getSubSuffix()
        break
      case OfferLinkPosition.CROSSROADS_SUBSCRIPTION_OFFER:
        ref = 'static_diskusie_profil_hore' + getSubSuffix()
        break
      case OfferLinkPosition.CROSSROADS_SUPER_LIKE_OFFER:
        ref = 'static_diskusie_profil_superlike' + getSubSuffix()
        break
      case OfferLinkPosition.POST_TOOLTIP_EDIT:
        ref = 'static_diskusie_post_edit' + getSubSuffix()
        break
      case OfferLinkPosition.POST_TOOLTIP_SUPER_LIKE_UPGRADE_TO_PREMIUM:
        ref = 'static_diskusie_post_superlike' + getSubSuffix()
        break
      case OfferLinkPosition.POST_TOOLTIP_SUPER_LIKE_BUY_SUBSCRIPTION:
        ref = 'static_diskusie_post_superlike' + getSubSuffix()
        break
    }

    if (ref) {
      url.searchParams.append('ref', ref)
    }

    urlCache[key] = url.toString()
    return urlCache[key]
  }

  return {
    addRef,
  }
}
